import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const ProductionFeedEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({}); 
     const [productnameLists, setproductnameLists] = useState([]);
      const [locationLoading, setLocationLoading] = useState([]);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [permission, setPermission] = useState({});


  useEffect(() => {
  

    axios
      .get(`/production-feeds/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          toast.error(response.data.data.production);
          setValue(response.data.data.production);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: value.id,
      shift_date: value.shift_date,
      shift: value.shift,
      product_type:value.product_type,
      product: value.product,
      location: value.location,
      quantity_processed:value.quantity_processed
    },
    enableReinitialize: true,
    onSubmit: (values,{ setSubmitting }) => {
      axios
        .post("/production-feeds/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
         // actions.setSubmitting(false);
          $("#form-submit").text("Update Production Feed");
          if (response.data.code === 200) {
            
            toast.success(response.data.message);
           // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/production-feeds";
            }, 1000);
          }  else if (response.data.code === 422) {
            setSubmitting(false);
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setSubmitting(false);
            setBackendErrors(response.data.error);
          }
          else {
            setSubmitting(false);
             setBackendErrors(response.data.error);
          }

        })
        .catch((error) => {
          console.log(error);
          //actions.setSubmitting(false);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
        setPermission(FindModuleById(454)); 
      console.log(permission);

   axios.post(
        "/products/listing-groupby",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
         // setBarcodeProducts(products);
         console.log(products);
          let productslisting = products.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `prodct-${index}`,
          }));
          setproductnameLists(productslisting);
          console.log(productnameLists);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  

      axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let productslisting = response.data.data.locations;

          //let farmers = response.data.data.farmers;
          let locations = productslisting.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `farmer-${index}`,
          }));
          
           setLocationLoading(locations);
          
        } else {
          console.log("API response is not an array");
        }
      }) .catch((error) => {
        console.log(error);
      });
  }, []);
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };

  const producttype = [
     { value: 'A', label: "A"},
  { value: 'B', label: "B" },
  { value: 'Puree', label: "Puree" }
];
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Feeds</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-feeds">Production Feeds</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Edit Production Feeds
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.update === 1 && (
                  <div className="card-body">
                    <h4 className="card-title">Production Feed Info</h4>
                     <FormikProvider value={formik}>
                     <form action="#" onSubmit={formik.handleSubmit}>
                      <div className="row">
                        <div className="col-md-4">
                            <div className="form-group order status">
                              <label>Location</label>
                              {locationLoading.length > 0 && (
                                <Select
                                className="w-100"
                                value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                                name="location"
                                onChange={(selectedOption) => {
                                  handleSelectChange("location", selectedOption);
                                }}
                                onBlur={formik.handleBlur}
                                options={locationLoading}
                                placeholder="Select"
                            />
                              )}
                             
                             
                            </div>
                            <small>
                              {backendErrors.location && (
                                <span className="form-error mt-1">
                                  {backendErrors.location}
                                </span>
                              )}
                            </small>
                          </div>
                        <div className="col-md-4">
                            <div className="form-group order status">
                              <label>Product</label>
                               {productnameLists.length > 0 && (
                                <Select
                              className="w-100"
                              value={productnameLists.find(option => option.value == formik.values.product) || null} // Ensure correct format
                              name="product"
                              onChange={(selectedOption) => {
                              handleSelectChange("product", selectedOption);
                            //   generateLotNumberLocation(selectedOption.value);
                              }}
                              onBlur={formik.handleBlur}
                              options={productnameLists}
                              placeholder="Select"
                            />
                               )}
                             
                           
                            </div>
                            <small>
                              {backendErrors.product && (
                                <span className="form-error mt-1">
                                  {backendErrors.product}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group order status">
                                <label>Product Type</label>
                                <Select
                                className="w-100"
                                value={producttype.find(option => option.value == formik.values.product_type) || null} // Ensure correct format
                                name="product_type"
                                onChange={(selectedOption) => {
                                handleSelectChange("product_type", selectedOption);
                              //   generateLotNumberLocation(selectedOption.value);
                                }}
                                onBlur={formik.handleBlur}
                                options={producttype}
                                placeholder="Select"
                              />
                              
                              </div>
                              <small>
                                {backendErrors.product && (
                                  <span className="form-error mt-1">
                                    {backendErrors.product}
                                  </span>
                                )}
                              </small>
                            </div>
                           
                        <div className="col-md-4">
                            <div className="form-group">
                              <label>Shift Date </label>
                              <input
                                type="date"
                                name="shift_date"
                                value={formik.values.shift_date}
                                className="form-input form-control"
                                
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                               
                          
                                }} 
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.shift_date && (
                                  <span className="form-error mt-1">
                                    {backendErrors.shift_date}
                                  </span>
                                )}
                              </small>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Shift (1 or 2)</label>
                              <input
                                
                                type="text"
                                onKeyPress={(event) => {
                                  // Allow only numbers (0-9)
                                  if (!/^[0-9]$/.test(event.key)) {
                                  event.preventDefault();
                                  }
                                }}
                                name="shift"
                                value={formik.values.shift}
                                className="form-input form-control"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                               
                          
                                }} 
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.shift && (
                                  <span className="form-error mt-1">
                                    {backendErrors.shift}
                                  </span>
                                )}
                              </small>
                            </div>
                          </div>
                       
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Quantity Processed (KG)</label>
                              <input
                                
                                type="text"
                                 onKeyPress={(event) => {
                                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                        event.preventDefault();
                                      }
                                    }}
                                name="quantity_processed"
                                value={formik.values.quantity_processed}
                                className="form-input form-control"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                                           
                                }} 
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.quantity_processed && (
                                  <span className="form-error mt-1">
                                    {backendErrors.quantity_processed}
                                  </span>
                                )}
                              </small>
                            </div>
                          </div>
                     
                  
                      </div>
                      <small>
                          {backendErrors.status  && (
                            <span className="form-error mt-1">
                              {backendErrors.status}
                            </span>
                          )}
                        </small>
                      <div className="text-end mt-4">
                        <button
                          type="submit" id="form-submit"
                          className="btn btn-primary"
                          disabled={formik.isSubmitting}
                        >
                          Update Production Feed
                        </button>
                      </div>
                    </form>
                     </FormikProvider>
                   
                  </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionFeedEdit;
